"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupKeyFactory = void 0;
var flApi = require("./flApi");
var groupKeyFactory = (function () {
    function groupKeyFactory() {
        var _this = this;
        this.gkeys = new Array();
        this.paramEcns = [];
        this._ttxId = 0;
        this.notifParamObject = function (msg) {
            try {
                if (msg.type === "data" && msg.eCN === 100) {
                    _this._ttxId++;
                    msg.data.forEach(function (aDataNotif) {
                        switch (msg.operation) {
                            case "i":
                                _this.insertJDoc(aDataNotif);
                                break;
                            case "u":
                                _this.updateJDoc(aDataNotif);
                                break;
                            case "d":
                                _this.deleteJDoc(aDataNotif);
                                break;
                        }
                    });
                }
                return [];
            }
            catch (err) {
                console.error(err.stack);
                throw err;
            }
        };
    }
    groupKeyFactory.prototype.resetAndLoad = function (m100) {
        var _this = this;
        try {
            if (this.fl === undefined) {
                this.fl = flApi.Api.getInstance();
                this.fl.restApi.addNotificationHandler("GroupKeys", this.notifParamObject, 1);
            }
            this.gkeys = new Array();
            m100.forEach(function (aM100) {
                _this.insertJDoc(aM100);
            });
        }
        catch (err) {
            console.error(err.stack);
            throw err;
        }
    };
    groupKeyFactory.prototype.reloadAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var m100;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.fl.getAllDocuments(100)];
                    case 1:
                        m100 = (_a.sent());
                        this.resetAndLoad(m100);
                        return [2];
                }
            });
        });
    };
    groupKeyFactory.prototype.ttxId = function () {
        return this._ttxId;
    };
    groupKeyFactory.prototype.getAll = function (serviceName, gkFcn, startDate, EndDate) {
        if (gkFcn === void 0) { gkFcn = -1; }
        var startDT = (startDate === undefined) ? 0 : startDate.getTime();
        var endDT = (EndDate === undefined) ? new Date(2100, 1, 1).getTime() : EndDate.getTime();
        return this.gkeys.filter(function (g) {
            if (startDT < g.dateLast && endDT > g.dateFirst && g.service === serviceName) {
                if (g.fCN.length === 0 || gkFcn === -1 || g.fCN[g.fCN.length - 1] === gkFcn) {
                    return true;
                }
            }
            return false;
        });
    };
    groupKeyFactory.prototype.getOne = function (id) {
        var tmpGK = this.gkeys.filter(function (g) { return g.id === id; });
        return tmpGK.length === 0 ? undefined : tmpGK[0];
    };
    groupKeyFactory.prototype.getAllPerAction = function (serviceName, action, gkFcn) {
        if (gkFcn === void 0) { gkFcn = -1; }
        var tmpGK = this.gkeys.filter(function (g) {
            if (g.service === serviceName) {
                if (g.fCN.length === 0 || gkFcn === -1 || g.fCN[g.fCN.length - 1] === gkFcn) {
                    return (g.action === action);
                }
            }
            return false;
        });
        return tmpGK.length === 0 ? undefined : tmpGK[0];
    };
    groupKeyFactory.prototype.getAllPerFcn = function (serviceName, fCNs) {
        var result = [];
        if (fCNs.length === 0) {
            return [];
        }
        this.gkeys.forEach(function (aGK) {
            if (aGK.service === serviceName) {
                var fcnIdx = fCNs.length;
                var agkIdx = aGK.fCN.length;
                var bMatch = true;
                while (bMatch && fcnIdx > 0) {
                    bMatch = fCNs[--fcnIdx] === aGK.fCN[--agkIdx];
                }
                if (bMatch) {
                    result.push(aGK);
                }
            }
        });
        return result;
    };
    groupKeyFactory.prototype.delete = function () {
        throw new Error("Method not implemented.");
    };
    groupKeyFactory.prototype.insertJDoc = function (jGroupKey) {
        var tmpGK = {
            id: jGroupKey.id,
            action: jGroupKey.c101,
            service: jGroupKey.c107,
            dateFirst: jGroupKey.c102,
            dateLast: jGroupKey.c103,
            split: jGroupKey.c104,
            fCN: jGroupKey.c105,
            options: jGroupKey.c106,
        };
        this.gkeys.push(tmpGK);
    };
    groupKeyFactory.prototype.updateJDoc = function (jGroupKey) {
        var gkeyFound = this.gkeys.find(function (g) { return g.action == jGroupKey.c101; });
        if (gkeyFound === undefined) {
            return this.insertJDoc(jGroupKey);
        }
        gkeyFound.dateFirst = jGroupKey.c102;
        gkeyFound.dateLast = jGroupKey.c103;
        gkeyFound.split = jGroupKey.c104;
        gkeyFound.fCN = jGroupKey.c105;
        gkeyFound.options = jGroupKey.c106;
    };
    groupKeyFactory.prototype.deleteJDoc = function (jGroupKey) {
        var gkeyIdx = this.gkeys.findIndex(function (g) { return g.id == jGroupKey.id; });
        if (gkeyIdx > -1) {
            this.gkeys.splice(gkeyIdx);
        }
    };
    return groupKeyFactory;
}());
exports.groupKeyFactory = groupKeyFactory;
